import * as CONSTANT from "../../../constants";
import { IKidsComboModifierItem, IModifierGroups } from "../../../models/kidsCombo";
import { itemBuckets } from "../../../priceCalculation/buckets";
import uniqBy from "lodash.uniqby";
import { IParams } from "../../../models/card";
import { ISelectedItem } from "../../../models/try2Combo";
import { ADDITIONAL_ADDED } from "../../../priceCalculation/constants";
import _clonedeep from 'lodash.clonedeep'

export const removeSelectedModifiers = (
  type: string,
  index: number,
  selectedItemId: number
) => {
  const types = [];
  if (type === CONSTANT.ADD_ONS || type === CONSTANT.COMPLIMENTARY_MODIFIER) {
    types.push(CONSTANT.REQUIRED_MODIFIERS);
    types.push(type);
  } else if (type) {
    types.push(type);
  }
  return itemBuckets.reintializeBuckets({
    bucketNames: types,
    itemNo: selectedItemId,
  });
};

export const getCurrentSelectedModifierFromAPI = (currentSelectedItem,modifier_group_id, modifier_id) => {
  const requiredGroup = currentSelectedItem?.kids_required_modifier_groups.find(modifierGroup => modifierGroup.id === modifier_group_id);
  return requiredGroup?.modifiers_groups_modifiers?.find(modifier => modifier?.id === modifier_id)

}

export const currentSelectedItem = (
  modifiersAsItems,
  selectedItem: ISelectedItem,
  id: string
) => {
  const currentSelectedItem =
    selectedItem &&
    id === selectedItem.item &&
    modifiersAsItems?.find((item) => item.id == selectedItem.id);
  if (currentSelectedItem?.is_nested_kids_combo) {
    const fromItem:any = parseInt(id) - 1;
    const currentSelectedItemRequiredModifierFromBucket =
      itemBuckets.getSingleBucketKeyValue(
        {name:CONSTANT.REQUIRED_MODIFIERS,
        fromItem,
        modifierType:ADDITIONAL_ADDED,
        key:"modifiers"}
      )[0];
    if (currentSelectedItemRequiredModifierFromBucket) {
      const currentSelectedItemRequiredModifier =
        currentSelectedItemRequiredModifierFromBucket;
      const currentSelectedItemRequiredModifierFromAPI =
        getCurrentSelectedModifierFromAPI(
          currentSelectedItem,
          currentSelectedItemRequiredModifier?.modifier_group_id,
          currentSelectedItemRequiredModifier?.modifier_id
        );
      if (currentSelectedItemRequiredModifierFromAPI) {
        return currentSelectedItemRequiredModifierFromAPI;
      }
    }
  }
  return currentSelectedItem;
};


export const selectedIngredients = (selectedItemId, type) => {
  return itemBuckets.specificItemBucketSelectedModifiers( 
    type,
    selectedItemId
  );
};

export const currentSelectedModifier = (modifier, selectedItemId, type) => {
  const selectedModifiers = selectedIngredients(selectedItemId, type);
  if (selectedModifiers) {
    return selectedModifiers.find(
      (selected) => selected.modifier_id === modifier.id
    );
  } else {
    return selectedModifiers;
  } 
};

export const distingModifierType = (data: IParams, modifierGroup: IKidsComboModifierItem, handleIngredientSelection: any) => {
  const type = modifierGroup?.type;
  if (type === CONSTANT.REQUIRED_MODIFIERS) {
    handleIngredientSelection({
      ...data,
      modifier_type: CONSTANT.REQUIRED_MODIFIERS,
      modifier_group_id: modifierGroup?.id,
      modifier_group_max: modifierGroup?.max,
      modifier_group_min: modifierGroup?.min,
      brink_modifier_group_id:
        modifierGroup?.brink_modifier_group_id,
        modifier_group_base: modifierGroup?.base
    });
  } else if (type === CONSTANT.ADD_ONS) {
    handleIngredientSelection({
      ...data, modifier_type: CONSTANT.ADD_ONS,
      modifier_group_id: modifierGroup?.id,
      modifier_group_max: modifierGroup?.max,
      extendableLimitValue: modifierGroup?.extendable_limit,
      modifier_group_min: modifierGroup?.min,
      modifier_group_base: modifierGroup?.base,
    });
  } else if (type === CONSTANT.COMPLIMENTARY_MODIFIER) {
    handleIngredientSelection({
      ...data,
      complimentary_modifier: true,
      modifier_type: CONSTANT.COMPLIMENTARY_MODIFIER,
      modifier_group_id: modifierGroup?.id,
      modifier_group_max: modifierGroup?.max,
    });
  }
};

export const pushItemModifiersToQueue = (item: IKidsComboModifierItem, queue: IModifierGroups[]) => {
  if (item?.kids_required_modifier_groups[0])
    queue.push({
      type: CONSTANT.REQUIRED_MODIFIERS,
      ...item?.kids_required_modifier_groups[0],
    });
  if (item?.kids_modifier_groups[0])
    queue.push({
      type: CONSTANT.ADD_ONS,
      ...item?.kids_modifier_groups[0],
    });
  if (item?.kids_complementary_modifier_groups[0])
    queue.push({
      type: CONSTANT.COMPLIMENTARY_MODIFIER,
      ...item?.kids_complementary_modifier_groups[0],
    });
}

const removeItemFromModifierGroupsQueue = (item: IKidsComboModifierItem, itemStack: IKidsComboModifierItem[], tempItemStack: IKidsComboModifierItem[]) => {
  const tempModifierGroupsQueue = [];
  for (let i = 0; i < itemStack.length; i += 1) {
    if (itemStack[i].id === item.id) break;
    tempItemStack.push({ ..._clonedeep(itemStack[i]) });
    const currentItem = itemStack[i]
    pushItemModifiersToQueue(currentItem, tempModifierGroupsQueue)
  }
  return tempModifierGroupsQueue
}

export const removeItemFromItemStack = (item: IKidsComboModifierItem, itemStack: IKidsComboModifierItem[], modifierGroupsQueue: IModifierGroups[]) => {
  let tempItemStack = [];
  const tempModifierGroupsQueue = removeItemFromModifierGroupsQueue(item, itemStack, tempItemStack)
  const tempItemStackItemIds = tempItemStack?.map((item) => item.id);
  modifierGroupsQueue.length = 0;
  modifierGroupsQueue.push(
    ...tempModifierGroupsQueue.filter((modifier) => {
      const modifierGroupsModifierIds =
        modifier?.modifiers_groups_modifiers?.filter(
          (modifierGroupModifier) =>
            tempItemStackItemIds.includes(modifierGroupModifier.id)
        );
      return !tempItemStackItemIds.includes(modifierGroupsModifierIds[0]?.id);
    })
  );
  return tempItemStack
}

export const getModifierGroup = (item: IKidsComboModifierItem, modifierGroupsQueue: IModifierGroups[], shouldReset: boolean = false) => {
  const copyOfModifierGroupsQueue = modifierGroupsQueue.length
    ? _clonedeep(modifierGroupsQueue)
    : [];
  pushItemModifiersToQueue(item, modifierGroupsQueue)
  const tempModifierGroupsQueue = uniqBy(modifierGroupsQueue, "id");
  modifierGroupsQueue.length = 0;  
  if (shouldReset) {
    if (copyOfModifierGroupsQueue?.length)
      modifierGroupsQueue.push(...copyOfModifierGroupsQueue);
    return tempModifierGroupsQueue?.length ? tempModifierGroupsQueue[0] : {};
  }
  modifierGroupsQueue.push(...tempModifierGroupsQueue);
  if (modifierGroupsQueue?.length > 1) return modifierGroupsQueue.shift();
  if (modifierGroupsQueue?.length) {
    if (modifierGroupsQueue[0].type === CONSTANT.REQUIRED_MODIFIERS) return modifierGroupsQueue.shift()
    return modifierGroupsQueue[0]
  }
  return {};
};

export const getCustomizedItemStack = (
  selectedItemId: string,
  modifierGroupsQueue: IModifierGroups[],
  requiredItemAsModifier: IKidsComboModifierItem[],
  selectedModifierAsItems: any,
) => {
  const requiredModifiersSelected = selectedIngredients(selectedItemId, CONSTANT.REQUIRED_MODIFIERS)
  const item = _clonedeep(
    requiredItemAsModifier?.find(
      (requiredItem) =>
        selectedModifierAsItems.find(
          (modifierAsItem) => modifierAsItem.item === selectedItemId
        )?.id === requiredItem.id
    )
  );
  item.is_selected = true;
  item.type = CONSTANT.REQUIRED_MODIFIERS;
  const tempItemStack = [item];
  const requiredItem = _clonedeep(
    getModifierGroup(item, modifierGroupsQueue)?.modifiers_groups_modifiers?.find(
      (modifier) => modifier.id === requiredModifiersSelected[0]?.modifier_id
    )
  );
  if (requiredItem && Object.keys(getModifierGroup(requiredItem, modifierGroupsQueue))?.length) {
    requiredItem.is_selected = true;
    requiredItem.type = CONSTANT.REQUIRED_MODIFIERS;
    tempItemStack.push(requiredItem);
  }
  return tempItemStack
};

export const calculateCalories = (modifiers:any[]) => {
  let calories = 0
  for (let index = 0; index < modifiers?.length; index++) {
    calories += modifiers[index]?.modifier_calories ?? 0
  }
  return calories
}